import React from "react";
import { useLocation } from "react-router-dom";

import jrpdf from "../pdf/jr.pdf";
import nupdf from "../pdf/nu.pdf";

const Pdf2 = (props) => {
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);

	const Qpdf = () => {
		const qpdf = queryParams.get("pdf");
		switch (qpdf) {
			case "nu":
				return nupdf;
			case "jr":
				return jrpdf;
			default:
				return null;
		}
	};
	// console.log("return value ------", Qpdf());
	return <div style={{ height: "100vh" }}>{Qpdf() ? <iframe src={`${Qpdf()}#toolbar=0&navpanes=0&view=fitH`} title="rightframe" width="100%" height="100%"></iframe> : <h1> NO FILE !!!</h1>}</div>;
};

export default Pdf2;
